import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import biometricsHero from "../assets/Hero/biometrics-hero.jpg"; // Replace with your hero image
import biometricsImage from "../assets/Hero/biometrics.jpg"; // Replace with your biometrics image
import featuresImage from "../assets/Hero/Nairobi.jpg"; // Replace with your features image
import "../assets/css/biometricsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const biometricsData = {
  hero: {
    title: "Biometric Solutions",
    subtitle: "Enhancing Security with Advanced Biometric Technology",
  },
  introduction: {
    heading: "Why Biometric Solutions Matter",
    paragraphs: [
      "Biometric systems provide a secure and efficient way to authenticate individuals using unique biological traits such as fingerprints, facial recognition, and more.",
      "Our biometric solutions are designed to offer high accuracy, seamless integration, and enhanced security for your business.",
    ],
  },
  features: {
    heading: "Our Biometric Solutions Features",
    items: [
      "Fingerprint Recognition",
      "Facial Recognition",
      "Iris Scanning",
      "Voice Authentication",
      "Seamless Integration with Existing Systems",
      "24/7 Expert Support",
    ],
  },
  benefits: {
    heading: "Benefits of Our Solutions",
    items: [
      {
        icon: "fa fa-fingerprint",
        text: "Enhanced security with unique biometric authentication.",
      },
      {
        icon: "fa fa-shield",
        text: "Reduced risk of unauthorized access.",
      },
      {
        icon: "fa fa-line-chart",
        text: "Scalable solutions for businesses of all sizes.",
      },
      {
        icon: "fa fa-check-circle",
        text: "Compliance with industry standards and regulations.",
      },
      {
        icon: "fa fa-headphones",
        text: "Expert support for seamless operations.",
      },
    ],
  },
  cta: {
    heading: "Ready to Secure Your Business with Biometrics?",
    text: "Contact us today to learn more about our Biometric Solutions and how we can help protect your business.",
  },
};

export const BiometricsPage = ({ data }) => {
  const biometricsRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = biometricsRef.current.querySelectorAll(".biometrics-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: biometricsRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="biometrics-page" ref={biometricsRef}>
      {/* Hero Section */}
      <div
        className="biometrics-hero-section"
        style={{ backgroundImage: `url(${biometricsHero})` }}
      >
        <h1 className="biometrics-animate">{biometricsData.hero.title}</h1>
        <p className="biometrics-animate">{biometricsData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container biometrics-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="biometrics-animate">{biometricsData.introduction.heading}</h2>
            {biometricsData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="biometrics-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 biometrics-image-container">
            <img
              src={biometricsImage}
              className="img-fluid biometrics-animate"
              alt="Biometric Solutions"
            />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container biometrics-features">
        <div className="row">
          <div className="col-md-6 biometrics-image-container">
            <img
              src={biometricsHero}
              className="img-fluid biometrics-animate"
              alt="Biometric Features"
              style={{ maxWidth: "100%" }}
            />
          </div>
          <div className="col-md-6">
            <h2 className="biometrics-animate">{biometricsData.features.heading}</h2>
            <ul>
              {biometricsData.features.items.map((item, index) => (
                <li key={index} className="biometrics-animate">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div
        className="container-fluid biometrics-benefits"
        style={{ backgroundImage: `url(${featuresImage})` }}
      >
        <div className="overlay">
          <h2 className="biometrics-animate">{biometricsData.benefits.heading}</h2>
          <div className="benefits-cards">
            {biometricsData.benefits.items.map((item, index) => (
              <div key={index} className="benefit-card biometrics-animate">
                <i className={item.icon}></i>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container biometrics-cta">
        <h2 className="biometrics-animate">{biometricsData.cta.heading}</h2>
        <p className="biometrics-animate">{biometricsData.cta.text}</p>
        <button
          className="btn btn-primary biometrics-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};